import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { waitForUserProfile } from '@/core/auth/guards/wait-for-user-profile';
import { RoleType } from '../constants/role.constants';

/**
 * Guard that checks if the user has any admin role (SYSTEM_ADMIN, ORGANIZATION_ADMIN, or TEAM_LEAD)
 * Use this for routes that should be accessible to any administrator.
 */
export const adminGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return waitForUserProfile(store).pipe(
    map((user) => {
      const adminRoles = [RoleType.SYSTEM_ADMIN, RoleType.ORGANIZATION_ADMIN, RoleType.TEAM_LEAD];

      const hasAdminRole = user?.roles?.some((role: any) => adminRoles.includes(role.type as RoleType)) || false;

      if (!hasAdminRole) {
        console.warn('AdminGuard: Access denied - User does not have any admin role');
        router.navigate(['/apps/opportunity-management']);
        return false;
      }

      return true;
    })
  );
};
